var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled, ThemeProvider } from '../theme-provider';
import { MediaContext, SetMediaContext } from './media-context';
import { getCommonProps, getUncommonProps, } from '../helpers/common-props';
export const VideoControlAreaContext = React.createContext(undefined);
const StyledVideo = styled.video.withConfig({ displayName: "StyledVideo", componentId: "sc-fxbl2v" }) `width:100%;height:100%;`;
const StyledVideoWrapper = styled.div.withConfig({ displayName: "StyledVideoWrapper", componentId: "sc-1d0bbt6" }) `position:relative;display:flex;`;
const StyledControlArea = styled.div.withConfig({ displayName: "StyledControlArea", componentId: "sc-1i1q6uf" }) `position:absolute;top:0;left:0;height:100%;width:100%;display:flex;flex-direction:column;justify-content:flex-end;`;
export const Video = (props) => {
    const _a = getUncommonProps(props), { children, videoChildren, onFullscreenChange } = _a, others = __rest(_a, ["children", "videoChildren", "onFullscreenChange"]);
    const commonProps = getCommonProps(props);
    const setMedia = React.useContext(SetMediaContext);
    const VideoRef = React.useRef(null);
    const [mediaElement, setMediaElement] = React.useState();
    const VideoWrapperRef = React.useRef(null);
    const ControlAreaRef = React.useRef(null);
    const [controlAreaElement, setControlAreaElement] = React.useState();
    React.useEffect(() => {
        setMedia && setMedia(VideoRef.current);
    }, [setMedia, VideoRef]);
    React.useEffect(() => {
        setMediaElement(VideoRef.current);
    }, [VideoRef]);
    React.useEffect(() => {
        setControlAreaElement(ControlAreaRef.current);
    }, [ControlAreaRef]);
    React.useEffect(() => {
        if (!onFullscreenChange || !VideoWrapperRef.current) {
            return;
        }
        const VideoWrapperElement = VideoWrapperRef.current;
        const handleFullscreenChange = () => {
            onFullscreenChange({
                fullscreen: document.fullscreenElement === VideoWrapperElement ? true : false,
            });
        };
        VideoWrapperElement.addEventListener('fullscreenchange', handleFullscreenChange);
        return () => {
            VideoWrapperElement.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, [VideoWrapperRef, onFullscreenChange]);
    const handleClick = React.useCallback(() => {
        if (!VideoRef || !VideoRef.current) {
            return;
        }
        const paused = VideoRef.current.paused;
        if (paused) {
            VideoRef.current.play();
        }
        else {
            VideoRef.current.pause();
        }
    }, [VideoRef]);
    return (React.createElement(StyledVideoWrapper, Object.assign({}, commonProps, { ref: VideoWrapperRef }),
        React.createElement(StyledVideo, Object.assign({ ref: VideoRef }, others), videoChildren),
        React.createElement(MediaContext.Provider, { value: mediaElement },
            React.createElement(StyledControlArea, { onClick: handleClick, ref: ControlAreaRef },
                React.createElement(ThemeProvider, { theme: "inverted" },
                    React.createElement(VideoControlAreaContext.Provider, { value: controlAreaElement }, children))))));
};
Video.displayName = 'Video';
